import React from 'react';
import classnames from 'classnames';
import s from './FeedSidebar.scss';

export interface Props {
  className?: string;
}

const FeedSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
}) => (
  <div className={classnames(s['root'], className)}>
    <div>{children}</div>
  </div>
);
FeedSidebar.displayName = 'FeedSidebar';

export default FeedSidebar;
